import { render, staticRenderFns } from "./VaIconFresh.vue?vue&type=template&id=32465a0d&"
import script from "./VaIconFresh.vue?vue&type=script&lang=js&"
export * from "./VaIconFresh.vue?vue&type=script&lang=js&"
import style0 from "./VaIconFresh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports